<section class="p-2 h-min-full-header kp-spinner-container-lg h-100 w-100 container">
  <ngx-spinner name="load" [fullScreen]="false" type="timer"></ngx-spinner>
  <ng-container *ngIf="loaded">
    <div class="kp-message kp-message-error mx-0 text-center py-3" *ngIf="!seeker?.Seeker || seeker?.Seeker?.Disabled">
      <h3 class="mx-0">
        این رزومه حذف ویا دسترسی به آن محدود شده است
      </h3>
    </div>
    <div class="" *ngIf="payment" [ngSwitch]="payment?.Status">
      <div class="col-12">
        <div class="kp-card f-white green-bg" *ngSwitchCase="3">
          <h4>پرداخت با موفقیت انجام شد.
          </h4>
          <p>شماره پیگیری : <span>{{payment?.Token}}</span></p>
          <p *ngIf="!user?.ResumeCredit">برای دریافت اطلاعات تماس رزومه لطفا صفحه را مجددا بارگذاری کنید.</p>
        </div>
        <div class="kp-card f-white orange-bg" *ngSwitchDefault>
          پرداخت نا موفق بود<br />
          اگر مبلغی از حساب شما کسر شده باشد براساس فرایند بانک عامل شما به کارت شما باز گردانده می‌شود

          <p>شماره پیگیری : <span>{{payment?.Token}}</span></p>
        </div>
      </div>
    </div>
    <ng-container *ngIf="seeker?.Seeker && !seeker.Seeker.Disabled">
      <div class="resume-top"></div>
      <div class="fs-normal">
        <div *ngIf="!showHeader && seeker.Username" class="border-bottom border-gray py-2">
          <ng-container *ngTemplateOutlet="contactInfo"></ng-container>
        </div>
        <div class="mb-3 pb-2 d-flex align-items-center border-bottom kp-print-hidden">
          <div class="flex-grow-1">
            کد رزومه: {{seeker.Seeker.Code}}
          </div>
          <div class="px-md-1 ">
            <div class="p-1 btn btn-sm fs-sm btn-secondary btn-sm px-2" (click)="share()">
              <i class="fa fa-share-alt ml-1 fs-lg" title="اشتراک گذاری رزومه"></i> به اشتراک بگذار
            </div>
            <div class="p-1 btn btn-sm fs-sm btn-secondary btn-sm px-2 mr-2  d-inline-block" style="cursor:pointer"
              (click)="downloadPdf()">
              <i class="fa fa-file-pdf ml-1 fs-lg" title="اشتراک گذاری رزومه"></i>دریافت فایل
            </div>
          </div>

        </div>
      </div>
      <div *ngIf="resumeCss" [innerHTML]="resumeCss"></div>
      <div *ngIf="resumeBody" [innerHTML]="resumeBody" class="overflow-x-auto w-100"></div>
      <div class="kp-card mx-0 kp-print-hidden" *ngIf="showSubscriptions && seeker.Seeker.PublicSubscribes?.length">
        <h6 class="d-flex align-items-center border-bottom ">
          <div class="icon-alert-gray icon-lg ml-2"></div>
          این کارجو گوش به زنگ استخدام برای موارد زیر است:
        </h6>
        <div *ngFor="let subscribe of seeker.Seeker.PublicSubscribes">
          <div class="badge badge-pill yellow-bg long-text fs-normal px-2 py-1">
            {{subscribe}}
          </div>
        </div>

      </div>

    </ng-container>
  </ng-container>
</section>


<ngx-smart-modal customClass="" #buyResumeModal identifier="buyResumeModal" [closable]="false">
  <div class="container-capped-sm relative" *ngIf="seeker?.Seeker">
    <ngx-spinner name="full-resume" [fullScreen]="false" size="small" type="timer"></ngx-spinner>
    <ng-container *ngIf="seeker.Seeker.IsAcceptable">
      <ng-container *ngIf="apply || user?.ResumeCredit">
        <h3>دریافت اطلاعات تماس رزومه</h3>
        <div class="d-flex align-items=center justify-content-between p-2">
          <div>اعتبار باقی‌ مانده:</div>
          <div class="py-1 px-3 f-white green-bg rounded-xl fs-lg text-center">{{user?.ResumeCredit|number}}</div>
        </div>
        <ng-container *ngIf="!apply">
          <div class="p-2">
            با دریافت اطلاعات تماس یکی از اعتبارهای شما خرج می‌شود.
          </div>
          <div class="p-3 d-flex align-items=center justify-content-between">
            <div class="btn btn-link" (click)="buyResumeModal.close()">انصراف</div>
            <div class="btn btn-primary" (click)="buyResume()">تایید</div>
          </div>

        </ng-container>
        <ng-container *ngIf="apply">
          <ng-container *ngTemplateOutlet="applyActions;context:{apply:apply}"> </ng-container>

          <div class="p-3 d-flex align-items=center justify-content-between">
            <div class="btn btn-secondary" (click)="apply=undefined;buyResumeModal.close()">بستن</div>
          </div>
        </ng-container>

      </ng-container>
      <ng-container *ngIf="!apply && !user?.ResumeCredit">
        <h3>خرید اعتبار دریافت اطلاعات تماس</h3>
        <div class="p-2">
          با خرید اعتبار مشاهده رزومه، می‌توانید به رزومه کامل کارجویان و اطلاعات تماس آنها دسترسی پیدا کنید.
        </div>
        <div class="p-3 d-flex align-items=center justify-content-between">
          <div class="btn btn-link" (click)="buyResumeModal.close()">انصراف</div>
          <div class="btn btn-primary" (click)="buyResume(true)">خرید اعتبار</div>
        </div>

      </ng-container>
    </ng-container>
    <ng-container *ngIf="!seeker.Seeker.IsAcceptable">
      <ng-container *ngIf="apply || user?.NotCompletedResumeCredit">
        <h3>دریافت اطلاعات تماس کارجوی گوش به زنگ</h3>
        <div class="d-flex align-items=center justify-content-between p-2">
          <div>اعتبار باقی‌ مانده:</div>
          <div class="py-1 px-3 f-white green-bg rounded-xl fs-lg text-center">
            {{user?.NotCompletedResumeCredit|number}}</div>
        </div>
        <ng-container *ngIf="!apply">
          <div class="p-2">
            با دریافت اطلاعات تماس یکی از اعتبارهای شما خرج می‌شود.
          </div>
          <div class="p-3 d-flex align-items=center justify-content-between">
            <div class="btn btn-link" (click)="buyResumeModal.close()">انصراف</div>
            <div class="btn btn-primary" (click)="buyResume()">تایید</div>
          </div>

        </ng-container>
        <ng-container *ngIf="apply">
          <ng-container *ngTemplateOutlet="applyActions;context:{apply:apply}"> </ng-container>

          <div class="p-3 d-flex align-items=center justify-content-between">
            <div class="btn btn-secondary" (click)="apply=undefined;buyResumeModal.close()">بستن</div>
          </div>
        </ng-container>

      </ng-container>
      <ng-container *ngIf="!apply && !user?.NotCompletedResumeCredit">
        <h3>دریافت اعتبار دریافت اطلاعات تماس</h3>
        <div class="p-2">
          کارجویی که انتخاب کردید در سایت کارپیشه اعلام آمادگی به کار داده است. جهت دریافت اعتبار رایگان برای دسترسی به
          شماره‌ی تماس با پشتیبانی کارپیشه تماس بگیرید:
          <div class="text-center my-2">
            <a class="rounded-xl border p-1 fs-xl fw-bold" href="tel:+982128429921">
              <span dir="ltr" class="d-inline-block text-left mr-2">021-28429921</span>
            </a>
          </div>
        </div>
        <div class="p-3 d-flex align-items=center justify-content-between">
          <div class="btn btn-link" (click)="buyResumeModal.close()">انصراف</div>
          <a class="btn btn-primary" href="tel:+982128429921">تماس با پشتیبانی کارفرمایان</a>
        </div>

      </ng-container>
    </ng-container>
  </div>
</ngx-smart-modal>
<ng-template #applyActions let-apply="apply">
  <div>
    <div class="mb-2" *ngIf="apply.Type == 1">
      <h6>آگهی مرتبط:</h6>
      <select [(ngModel)]="apply.JobId" (change)="updateApply(apply)">
        <option *ngFor="let job of jobs" [value]="job.Id">{{job.Title}}</option>
      </select>

    </div>
    <div class="mb-2">
      <h6>پوشه‌ها:
        <span class="fs-sm" *ngIf="!apply.Tags?.length">
          (می‌توانید این رزومه را در پوشه‌های دلخواه خود دسته‌بندی کنید.)</span>
      </h6>
      <ng-select name="tags" [items]="tags" [multiple]="true" [addTag]="true" [(ngModel)]="apply.Tags"
        addTagText="افزودن پوشه" [selectOnTab]="true" placeholder="نام پوشه را تایپ کنید" notFoundText=""
        (change)="updateApply(apply)" [maxSelectedItems]="10" [inputAttrs]="{maxlength:30}"></ng-select>
    </div>
    <div class="mb-2">
      <h6>یادداشت شما:</h6>
      <textarea class="fs-normal " rows="6" placeholder="یادداشت..." [(ngModel)]="apply.EmployerNotes"
        (change)="updateApply(apply)"></textarea>
    </div>

  </div>

</ng-template>
<ng-template #contactInfo>
  <h1 class="m-0 h4" *ngIf="seeker.Name">
    {{seeker.Name}}
  </h1>
  <h4 class="m-0 f-x-medium-gray" *ngIf="!seeker.Name">
    کارجوی بی‌نام
  </h4>

  <div class="d-flex align-items-center"><i class="fas fa-phone ml-2"></i>شماره تماس: <a
      href="tel:0{{seeker.Username}}">
      0{{seeker.Username}} </a>
    <app-whatsapp-message class="mr-3 fs-xxl" [mobile]="seeker.Username" [text]="whatsappMessage">
    </app-whatsapp-message>
  </div>
  <div *ngIf="seeker.Seeker.Email"><i class="fa fa-envelope ml-2"></i>ایمیل: <a class="no-wrap"
      *ngIf="seeker.Seeker.Email" href="mailto:{{seeker.Seeker.Email}}">
      {{seeker.Seeker.Email}} </a></div>

</ng-template>